import { render } from "./UserModal1_sub2.vue?vue&type=template&id=5e2f41a4"
import script from "./UserModal1_sub2.vue?vue&type=script&lang=ts"
export * from "./UserModal1_sub2.vue?vue&type=script&lang=ts"

import "./UserModal1_sub2.vue?vue&type=style&index=0&id=5e2f41a4&lang=css"
script.render = render

export default script